<app-auth-layout
  pageTitle="Create Account"
  subtitle="Already have an account?"
  actionLinkText="Log in"
  actionLinkRoute="/login"
>
  <form [formGroup]="registerForm" (ngSubmit)="register()" class="space-y-4">
    <div class="flex flex-col gap-1.5">
      <label for="email" class="text-sm font-semibold text-gray-700 ml-1"
        >Email Address</label
      >
      <input
        pInputText
        id="email"
        type="email"
        formControlName="email"
        class="w-full h-11 px-4 !bg-gray-50 border border-gray-200 focus:!bg-white focus:!border-[--primary-500] focus:ring-4 focus:ring-[--primary-100] outline-none text-sm transition-all rounded-lg"
        placeholder="Enter your email"
      />
      <small
        class="text-red-500 text-xs ml-1"
        *ngIf="
          registerForm.get('email').touched && registerForm.get('email').errors
        "
      >
        Valid email is required
      </small>
    </div>

    <div class="flex flex-col gap-1.5">
      <label for="password" class="text-sm font-semibold text-gray-700 ml-1"
        >Password</label
      >
      <div class="relative">
        <input
          pInputText
          id="password"
          [type]="showPassword ? 'text' : 'password'"
          formControlName="password"
          class="w-full h-11 px-4 pr-11 !bg-gray-50 border border-gray-200 focus:!bg-white focus:!border-[--primary-500] focus:ring-4 focus:ring-[--primary-100] outline-none text-sm transition-all rounded-lg"
          placeholder="Create a password"
        />
        <button
          type="button"
          (click)="showPassword = !showPassword"
          tabindex="-1"
          class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <i class="pi" [ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'"></i>
        </button>
      </div>
      <small
        class="text-red-500 text-xs ml-1"
        *ngIf="
          registerForm.get('password').touched &&
          registerForm.get('password').errors
        "
      >
        Password (4-16 chars) required
      </small>
    </div>

    <div class="flex flex-col gap-1.5">
      <label
        for="confirmPassword"
        class="text-sm font-semibold text-gray-700 ml-1"
        >Confirm Password</label
      >
      <div class="relative">
        <input
          pInputText
          id="confirmPassword"
          [type]="showConfirmPassword ? 'text' : 'password'"
          formControlName="confirmPassword"
          class="w-full h-11 px-4 pr-11 !bg-gray-50 border border-gray-200 focus:!bg-white focus:!border-[--primary-500] focus:ring-4 focus:ring-[--primary-100] outline-none text-sm transition-all rounded-lg"
          placeholder="Confirm your password"
        />
        <button
          type="button"
          (click)="showConfirmPassword = !showConfirmPassword"
          tabindex="-1"
          class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <i class="pi" [ngClass]="showConfirmPassword ? 'pi-eye-slash' : 'pi-eye'"></i>
        </button>
      </div>
      <small
        class="text-red-500 text-xs ml-1"
        *ngIf="
          registerForm.get('confirmPassword').touched &&
          registerForm.get('confirmPassword').hasError('isMatching')
        "
      >
        Passwords must match
      </small>
    </div>

    <button
      pButton
      type="submit"
      label="Register"
      class="w-full h-11 font-bold text-base bg-[--primary-500] text-white border-none hover:bg-[--primary-600] active:scale-[0.98] transition-all rounded-lg shadow-lg shadow-blue-500/20 mt-2"
      [disabled]="!registerForm.valid"
    ></button>
  </form>

  <div class="relative my-6">
    <div class="absolute inset-0 flex items-center">
      <div class="w-full border-t border-gray-200"></div>
    </div>
    <div class="relative flex justify-center text-xs uppercase tracking-wider">
      <span class="px-4 bg-white text-gray-400 font-semibold"
        >Or sign up with</span
      >
    </div>
  </div>

  <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
    <button
      type="button"
      (click)="microsoftLogin()"
      class="flex items-center justify-center gap-3 px-4 py-2.5 h-11 border border-gray-200 rounded-lg hover:bg-gray-50 hover:border-gray-300 transition-all text-sm font-semibold text-gray-700 bg-white group relative overflow-hidden"
    >
      <i
        class="pi pi-microsoft text-xl group-hover:text-[#00a4ef] transition-colors"
      ></i>
      <span>Microsoft</span>
    </button>

    <div class="relative group">
      <button
        type="button"
        class="flex items-center justify-center gap-3 px-4 py-2.5 h-11 w-full border border-gray-200 rounded-lg group-hover:bg-gray-50 group-hover:border-gray-300 transition-all text-sm font-semibold text-gray-700 bg-white"
      >
        <i
          class="pi pi-google text-xl text-gray-500 group-hover:text-[#DB4437] transition-colors"
        ></i>
        <span>Google</span>
      </button>

      <div
        class="absolute inset-0 z-10 opacity-0 overflow-hidden flex justify-center items-center"
      >
        <asl-google-signin-button type="standard" size="large" width="400">
        </asl-google-signin-button>
      </div>
    </div>
  </div>
</app-auth-layout>
